<template>
  <div class="trouble">
    <div v-if="index > -1">
      <div class="name">{{ts[index].name}}</div>
      <div class="hint">故障详情描述：</div>
      <div class="des" v-html="ts[index].des"></div>
      <div class="hint">处理意见：</div>
      <div class="sug" v-html="ts[index].sug"></div>
    </div>
  </div>
</template>

<script>
import troubles from "../../assets/js/bs_troubles"
export default {
  data(){
    return {
      index: -1,
      ts: troubles
    }
  },
  mounted(){
    this.index = parseInt(this.$route.params.ti)
  }
}
</script>

<style lang="less" scoped>
.trouble{
  min-height: 100%;
  box-sizing: border-box;
  background: #111117;
  padding: 40px 32px;
  .name{
    color: #f2f2f2;
    font-weight: 500;
    margin-bottom: 24px;
  }
  .hint{
    color: #f2f2f2;
    margin-bottom: 8px;
  }
  .des{
    font-size: 14px;
    color: #C7CAD1;
    margin-bottom: 16px;
    line-height: 21px;
  }
  .sug{
    font-size: 14px;
    color: #C7CAD1;
    line-height: 21px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/trouble.vue